import { useLocation } from 'react-router-dom';
import { useQueryParams } from 'hooks/routes/useQueryParams';
import { useNavigate } from 'hooks/routes';
import { Parameters } from 'constants/queryParameters';
import {
  AssetsIcon_24,
  DocumentIcon_24,
  GeneralInfoIcon_24,
  TransactionsIcon_24,
} from 'assets/icons';
import { NavTabItem, NavTabsContainer } from 'components/NavTabs';

import messages from './IraUserNavTabs.messages';

const IraUserNavTabs = (): JSX.Element => {
  const { pathname } = useLocation();
  const location = useLocation();
  const employerId = useQueryParams(Parameters.employerId);
  const iraUserId = useQueryParams(Parameters.iraUserId) ?? '';
  const contributionId = useQueryParams(Parameters.contributionId);

  // TODO: Refactor it to remove hardcode route
  const isIraUserPage = location.pathname.includes('/ira-accounts/ira-user');

  const {
    toIraUserRoleAdmin,
    toIraUserTransactions,
    toIraUserOpenOrders,
    toIraUserAssets,
    toContributionIRAUserDetail,
    toContributionIRAUserDetailTransactions,
    toContributionIRAUserDetailOpenOrders,
    toContributionIRAUserDetailAssets,
    toIraUserDetailsThroughIndependentIraTable,
    toIraUserTransactionsThroughIndependentIraTable,
    toIraUserOpenOrdersThroughIndependentIraTable,
    toIraUserAssetsThroughIndependentIraTable,
  } = useNavigate();

  const onGeneralInfoClick = (): void => {
    if (contributionId) {
      toContributionIRAUserDetail(contributionId, iraUserId, { replace: true });
    } else if (isIraUserPage) {
      toIraUserDetailsThroughIndependentIraTable(iraUserId, { replace: true });
    } else {
      toIraUserRoleAdmin(employerId, iraUserId, { replace: true });
    }
  };

  const onTransactionsClick = (): void => {
    if (contributionId) {
      toContributionIRAUserDetailTransactions(contributionId, iraUserId, {
        replace: true,
      });
    } else if (isIraUserPage) {
      toIraUserTransactionsThroughIndependentIraTable(iraUserId, { replace: true });
    } else {
      toIraUserTransactions(employerId, iraUserId, { replace: true });
    }
  };

  const onOpenOrdersClick = (): void => {
    if (contributionId) {
      toContributionIRAUserDetailOpenOrders(contributionId, iraUserId, {
        replace: true,
      });
    } else if (isIraUserPage) {
      toIraUserOpenOrdersThroughIndependentIraTable(iraUserId, { replace: true });
    } else {
      toIraUserOpenOrders(employerId, iraUserId, { replace: true });
    }
  };

  const onAssetsClick = (): void => {
    if (contributionId) {
      toContributionIRAUserDetailAssets(contributionId, iraUserId, { replace: true });
    } else if (isIraUserPage) {
      toIraUserAssetsThroughIndependentIraTable(iraUserId, { replace: true });
    } else {
      toIraUserAssets(employerId, iraUserId, { replace: true });
    }
  };

  return (
    <NavTabsContainer>
      <NavTabItem
        onClick={onGeneralInfoClick}
        isActive={pathname.includes('general-info')}
      >
        <GeneralInfoIcon_24 />
        {messages.generalInfo}
      </NavTabItem>

      <NavTabItem
        onClick={onTransactionsClick}
        isActive={pathname.includes('transactions')}
      >
        <TransactionsIcon_24 />
        {messages.transactions}
      </NavTabItem>

      <NavTabItem onClick={onOpenOrdersClick} isActive={pathname.includes('open-orders')}>
        <DocumentIcon_24 />
        {messages.openOrders}
      </NavTabItem>

      <NavTabItem onClick={onAssetsClick} isActive={pathname.includes('assets')}>
        <AssetsIcon_24 />
        {messages.assets}
      </NavTabItem>
    </NavTabsContainer>
  );
};

export default IraUserNavTabs;
